export default __webpack_public_path__ + "static/media/V490_RoHS.4c8bab8b.pdf";